/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Graduationinformation_Type1Inputs */

const de__field_graduationinformation_type1 = /** @type {(inputs: _Field_Graduationinformation_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abschlussart`)
};

/**

* @param {_Field_Graduationinformation_Type1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_graduationinformation_type1 = /** @type {((inputs?: _Field_Graduationinformation_Type1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Graduationinformation_Type1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_graduationinformation_type1(inputs)
});
export { _field_graduationinformation_type1 as "_field_graduationInformation_type" }